import { accountQueryKey, organizationsClaimsApi, RoleType } from 'api-validations/user-api'
import { type ApiClient, useApiClient, useMutation, useQueryClient } from 'shared-ui/api-provider'
import type { ApiError } from 'utils'

type Params = {
  orgCode: string
  username: string
}

const mutationFn =
  (client: ApiClient) =>
  async ({ orgCode, username }: Params) => {
    return await client
      .post(`/organizations/${orgCode}/useraccounts`, {
        body: { username, userRoleType: RoleType.Supporter }
      })
      .then((res) => ({
        success: res.status === 201,
        orgCode
      }))
  }

type Result = Awaited<ReturnType<ReturnType<typeof mutationFn>>>

export const useJoinOrgAsSupporter = () => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  return useMutation<Result, ApiError, Params>({
    mutationFn: mutationFn(apiClient),
    onSuccess: (_result, { username, orgCode }) => {
      queryClient.invalidateQueries({ queryKey: [accountQueryKey] })
      queryClient.invalidateQueries({
        queryKey: organizationsClaimsApi.queryKey({ username, orgCode })
      })
    }
  })
}
